import React, { useState, useEffect } from 'react'

import { Grid, Typography } from '@material-ui/core'

import useSnackbar from 'hooks/useSnackbar'
import helpers from 'helpers'

import {
  DashboardChartPaper,
  DashboardNumberCard,
  DonutChart,
  LinearProgressTable,
  LoadingFeedback,
} from 'components'

import constants from 'constants/index'
import * as service from 'service'

const DashboardAutomaticActivities = () => {
  const { SOURCE_ORIGIN_LABELS, KANBAN_COLUMN_ROLE_FINALIZED } =
    constants.activities

  const snackbar = useSnackbar()
  const [stats, setStats] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true)
        const response = await service.dponet.kanbanTasks.automaticStats()
        setStats(response.data)
      } catch (error) {
        snackbar.open({
          message: helpers.formatters.errorMessage(error),
          variant: 'error',
        })
      } finally {
        setLoading(false)
      }
    }
    load()
    // eslint-disable-next-line
  }, [])

  const byModule = (stats?.byModule || []).map((moduleStat) => ({
    ...moduleStat,
    name: SOURCE_ORIGIN_LABELS[moduleStat.moduleType] || moduleStat.moduleType,
  }))
  const maxCount = byModule?.[0]?.count || 1
  const moduleRows = byModule.map((moduleStat) => ({
    name: moduleStat.name,
    value: moduleStat.count,
    percentage: (moduleStat.count / maxCount) * 100,
  }))

  const allByStatus = stats?.byStatus || []
  const finalized = allByStatus.filter(
    (s) => s.role === KANBAN_COLUMN_ROLE_FINALIZED,
  )
  const others = allByStatus.filter(
    (s) => s.role !== KANBAN_COLUMN_ROLE_FINALIZED,
  )
  const byStatus = [...others.slice(0, 5), ...finalized]

  const donutNames = byStatus.map((s) =>
    s.title.length > 23 ? s.title.slice(0, 23) + '…' : s.title,
  )
  const donutValues = byStatus.map((s) => s.count)
  const donutColors = byStatus.map((s) => s.color)

  return (
    <>
      <LoadingFeedback open={loading} />
      <Grid item xs={12}>
        <Typography variant="h4" color="primary">
          Atividades Automáticas
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <DashboardNumberCard
          label="Total de Atividades Automáticas"
          value={stats?.total ?? 0}
          isLoading={loading}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <LinearProgressTable
          title="Módulos com mais Atividades"
          rows={loading ? [] : moduleRows}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DashboardChartPaper
          title="Atividades por Colunas"
          isLoading={loading}
          noMaxHeight
        >
          <DonutChart
            names={donutNames}
            values={donutValues}
            colors={donutColors}
            title="Automáticas"
            id="automatic-activities-status-donut"
            centerNameMaxChars={12}
          />
        </DashboardChartPaper>
      </Grid>
    </>
  )
}

export default DashboardAutomaticActivities
